import React from "react";
import AccommodationCard from "./AccommodationCard";

const sampleData = [
  {
    title: "Wilderness Club at Big Cedar",
    desc: "2 Bedroom Combined Lodge",
    date: "28 October — 1 November",
    price: 2016,
    beds: 4,
    sleeps: 8,
    size: 1350,
    rating: 4.8,
    images: [
      "https://plus.unsplash.com/premium_photo-1676823553207-758c7a66e9bb?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=870",
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1469",
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=658",
    ],
  },
  {
    title: "Wilderness Club at Big Cedar",
    desc: "2 Bedroom Combined Lodge",
    date: "28 October — 1 November",
    price: 2016,
    beds: 4,
    sleeps: 8,
    size: 1550,
    rating: 4.8,
    images: [
      "https://images.unsplash.com/photo-1564078516393-cf04bd966897?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=387",
      "https://plus.unsplash.com/premium_photo-1664301231899-5a7b1a621238?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=774",
      "https://images.unsplash.com/photo-1589834390005-5d4fb9bf3d32?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=387",
    ],
  },
];

const AccommodationList = () => {
  return (
    <>
      {sampleData.map((item, i) => (
        <AccommodationCard key={i} item={item} />
      ))}
    </>
  );
};

export default AccommodationList;
